// hooks/useAudio.js
import { useRef, useCallback } from "react";

function useAudio(src) {
  const audioRef = useRef(null);

  const getAudio = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio(src);
    }
    return audioRef.current;
  };

  const play = useCallback(() => getAudio().play().catch(() => { }), [src]);
  const stop = useCallback(() => {
    const a = getAudio();
    a.pause();
    a.currentTime = 0;
  }, [src]);
  const pause = useCallback(() => getAudio().pause(), [src]);

  return { play, stop, pause };
}

export default useAudio;